// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const EXTRACT_OR_REMOVE_LINES_STEP_SHAPES = [
  {
    stepType: PipelineStepType.EXTRACT_OR_REMOVE_LINES,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input file': {
        systemName: 'Input file',
        displayName: 'Input files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output file': {
        systemName: 'Output file',
        displayName: 'Output files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: true
      }
    },
    config: {
      actionType: {
        kind: 'enum',
        required: true,
        choices: [
          {
            value: 'EXTRACT_LINES',
            displayName: 'Extract lines'
          },
          {
            value: 'REMOVE_LINES',
            displayName: 'Remove lines'
          }
        ]
      },
      startLine: {
        kind: 'integer',
        required: true
      },
      endLine: {
        kind: 'integer',
        required: true
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
